import React from 'react'

import { FilterBox, FilterBoxItemState, UiFilterIcon } from '@octane/spark'
import useLeadsPageContext from 'pages/LeadsPage/LeadsPageContext'
import { ApplicationFilters } from 'pages/LeadsPage/types'
import { pushFilterSet } from 'utils/gtm-utils'

function buildInitialValue(
    initialValue?: ApplicationFilters,
): FilterBoxItemState[] {
    return [
        {
            value: 'prequalified',
            label: 'Prequalified leads',
            checked: initialValue?.prequalifiedLeads || false,
            group: 'Decision',
            order: 0,
        },
        {
            value: 'declined',
            label: 'Declined leads',
            checked: initialValue?.declinedLeads || false,
            group: 'Decision',
            order: 1,
        },
        {
            value: 'pre-approved',
            label: 'Pre-Approved leads',
            checked: initialValue?.preApprovedLeads || false,
            group: 'Decision',
            order: 2,
        },
    ]
}

function getApplicationsFilters(
    items: FilterBoxItemState[],
    currentFilters: ApplicationFilters,
): ApplicationFilters {
    return {
        prequalifiedLeads:
            items.find((item) => item.value === 'prequalified')?.checked ||
            false,
        declinedLeads:
            items.find((item) => item.value === 'declined')?.checked || false,
        preApprovedLeads:
            items.find((item) => item.value === 'pre-approved')?.checked ||
            false,
        dealershipIds: currentFilters.dealershipIds, // Preserve existing dealership filters
    }
}

function LeadsFilter(): JSX.Element {
    const { applicationFilters, setApplicationFilters } = useLeadsPageContext()

    return (
        <div>
            <FilterBox
                id="leadsPage__applicationsFilter"
                label="Filter"
                icon={UiFilterIcon}
                hideCounter
                open={false}
                multiple
                allowSorting={false}
                items={buildInitialValue()}
                onChange={(selectedItems) => {
                    const newApplicationFilters = getApplicationsFilters(
                        selectedItems,
                        applicationFilters,
                    )

                    if (
                        newApplicationFilters.declinedLeads !==
                        applicationFilters.declinedLeads
                    ) {
                        pushFilterSet('declinedLeads')
                    }

                    if (
                        newApplicationFilters.preApprovedLeads !==
                        applicationFilters.preApprovedLeads
                    ) {
                        pushFilterSet('preApprovedLeads')
                    }

                    if (
                        newApplicationFilters.prequalifiedLeads !==
                        applicationFilters.prequalifiedLeads
                    ) {
                        pushFilterSet('prequalifiedLeads')
                    }

                    setApplicationFilters(newApplicationFilters)
                }}
            />
        </div>
    )
}

export default LeadsFilter
